import { jwtDecode } from 'jwt-decode'
import { AuthPayload, User } from '@/features/auth/auth.def.ts'

export const decodeToken = (token: string): User => {
  const tokenPayload = jwtDecode<AuthPayload>(token)
  return {
    name: tokenPayload.sub,
    roles: tokenPayload.roles,
    env: tokenPayload.env,
    exp: tokenPayload.exp,
    token,
  }
}
